import { Link, Image } from '@shopify/hydrogen'
import { useInView } from 'react-intersection-observer'
// ----------------------------------------------------------------------

export default function RecipeCardDetailed({ recipe }) {
  const {
    slug,
    name,
    description,
    cocktail_plus_product_image,
    bitters,
    make_the_cocktail
  } = recipe
  const { ref: viewRef, inView } = useInView({
    threshold: 0
  })
  return (
    <>
      <div className='gap-2 mb-5 lg:grid group'>
        {/* <div className="overflow-x-scroll capitalize label">
          <p className="mb-0 uppercase whitespace-nowrap text-gold">
            {bitters.length > 0 && bitters.map((bitters, index) => {
                const { name } = bitters
                return (
                  <span key={index}>{index != 0 ? ', ' : ''}{' '}{name}
                  </span>
                )
              })
            }
          </p>
        </div> */}
        <Link to={`/recipes/${slug}`}>
          <h2>{name}</h2>
          <div className='relative z-10 px-0 overflow-hidden duration-500 image-frame w-fit'>
            {/* <Image src={ images[0].url } width={460} height={555} className="object-cover mx-auto rounded-none aspect-4/5" alt="A cocktail made with Bittercube Bitters" /> */}
            <div ref={viewRef}>
              {inView ? (
                <img
                  src={cocktail_plus_product_image}
                  className='mx-auto rounded-none'
                  alt='A cocktail made with Bittercube Bitters'
                />
              ) : (
                <>
                  <div className='w-full bg-dark h-96'></div>
                </>
              )}
            </div>
          </div>
        </Link>
        <div className='flex flex-wrap gap-2'>
          {make_the_cocktail.ingredients.length > 0 &&
            make_the_cocktail.ingredients.map((ingredient, index) => {
              if (ingredient.name.toLowerCase().includes('bitters')) {
                return (
                  <div key={index}>
                    <a
                      className='mt-0 mb-4 text-xs xl:text-sm btn btn-action whitespace-nowrap'
                      href={ingredient.link}
                    >
                      Shop {ingredient.name.replaceAll('Bittercube', '')}
                    </a>
                  </div>
                )
              }
            })}
        </div>
        <hr className='py-2' />
        <Link to={`/recipes/${slug}`}>
          <div className='flex items-center justify-start w-full gap-2 mx-auto label group'>
            <p className='mb-0 font-bold tracking-widest uppercase'>
              {name} Recipe
            </p>
            <div className='btn-arrow'></div>
          </div>
        </Link>
        {description && (
          <div className='overflow-x-hidden transition duration-700 opacity-0 group-hover:opacity-100 group-hover:flex text-dark line-clamp-1 group-hover:line-clamp-1'>
            {description}
          </div>
        )}
      </div>
    </>
  )
}
